import { Children, isValidElement, type ReactNode } from "react";
import type { SelectOption } from "./selectOption";

interface OptionElementProps {
  value?: string | number;
  children?: ReactNode;
  disabled?: boolean;
}

/** The plain text inside a React node (what an `<option>` would display). */
function textOf(node: ReactNode): string {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(textOf).join("");
  if (isValidElement<{ children?: ReactNode }>(node)) return textOf(node.props.children);
  return "";
}

/** `<option>` children → options (keeps the old native-select call sites working). */
export function optionsFromChildren(children: ReactNode): SelectOption[] {
  const out: SelectOption[] = [];
  Children.forEach(children, (child) => {
    if (!isValidElement<OptionElementProps>(child)) return;
    if (child.type === "option") {
      const label = textOf(child.props.children);
      out.push({ value: String(child.props.value ?? label), label, disabled: child.props.disabled });
    } else if (child.props.children) {
      out.push(...optionsFromChildren(child.props.children));
    }
  });
  return out;
}
